import React from 'react';
import {Table} from '@/web-components';
import {customFieldDisplayText} from '../../forecast-app/shared/util/customFieldValueValidation';

// The custom field cells of a row in the task and reported-time reports, one per field in the order given.
// Each reads as customFieldDisplayText writes it: a Dropdown or Multi-select as its option names ("Design,
// Backend, QA"), which only the value's displayValue carries; a Yes/No field as Yes or No in the viewer's
// language, and No when it is not set, as the report's CSV export reads it; a Currency amount with its symbol,
// in the separators and grouping of the viewer's locale (react-intl's locale), as the report's other money.
export const customFieldReportCells = (rowId, customFields, formatMessage, locale) =>
	customFields.map(customField => {
		const text = customFieldDisplayText(customField, formatMessage, '', {
			currencyCode: customField.currencyCode,
			locale,
		});
		return (
			<Table.Column key={rowId + '_' + customField.key}>
				<Table.Column.Cell title={text}>{text}</Table.Column.Cell>
			</Table.Column>
		);
	});
